export const parseBlobError = async (error: unknown): Promise<string> => {
    const err = error as {
        response?: { data?: Blob | { message?: string } };
        message?: string;
    };
    if (err?.response?.data instanceof Blob) {
        try {
            const text = await err.response.data.text();
            const json = JSON.parse(text) as { message?: string };
            return json.message || 'PDF 출력에 실패했습니다.';
        } catch {
            return 'PDF 출력에 실패했습니다.';
        }
    }
    const data = err?.response?.data;
    if (data && typeof data === 'object' && 'message' in data && typeof data.message === 'string') {
        return data.message;
    }
    return err?.message || 'PDF 출력에 실패했습니다.';
};

export const openPdfBlob = (blob: Blob): void => {
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 5000);
};
